import { APPEARANCE_ACTION_TYPES } from "../../constants/enrolledAppearanceConstants";

// Fetch Appearances
export const fetchAppearancesRequest = (payload) => ({
  type: APPEARANCE_ACTION_TYPES.FETCH_APPEARANCES_REQUEST,
  payload
});

export const fetchAppearancesSuccess = (data) => ({
  type: APPEARANCE_ACTION_TYPES.FETCH_APPEARANCES_SUCCESS,
  payload: data
});

export const fetchAppearancesFailure = (error) => ({
  type: APPEARANCE_ACTION_TYPES.FETCH_APPEARANCES_FAILURE,
  payload: error
});

// Delete Appearance
export const deleteAppearanceRequest = (appearanceId) => ({
  type: APPEARANCE_ACTION_TYPES.DELETE_APPEARANCE_REQUEST,
  payload: appearanceId
});

export const deleteAppearanceSuccess = (appearanceId) => ({
  type: APPEARANCE_ACTION_TYPES.DELETE_APPEARANCE_SUCCESS,
  payload: appearanceId
});

export const deleteAppearanceFailure = (error) => ({
  type: APPEARANCE_ACTION_TYPES.DELETE_APPEARANCE_FAILURE,
  payload: error
});

// Set Selected Appearance
export const setSelectedAppearance = (appearance) => ({
  type: APPEARANCE_ACTION_TYPES.SET_SELECTED_APPEARANCE,
  payload: appearance
});

// Clear Error
export const clearAppearanceError = () => ({
  type: APPEARANCE_ACTION_TYPES.CLEAR_APPEARANCE_ERROR
});

// Create Appearance
export const createAppearanceRequest = (appearanceName) => ({
  type: APPEARANCE_ACTION_TYPES.CREATE_APPEARANCE_REQUEST,
  payload: {
    appearanceName
  }
});

export const createAppearanceSuccess = (appearanceObj) => ({
  type: APPEARANCE_ACTION_TYPES.CREATE_APPEARANCE_SUCCESS,
  payload: { appearanceObj }
});

export const createAppearanceFailure = (error) => ({
  type: APPEARANCE_ACTION_TYPES.CREATE_APPEARANCE_FAILURE,
  payload: error
});

// Reset Create Success
export const resetCreateSuccess = () => ({
  type: APPEARANCE_ACTION_TYPES.RESET_CREATE_SUCCESS
});

// Upload Appearance Image
export const uploadAppearanceImageRequest = (payload) => ({
  type: APPEARANCE_ACTION_TYPES.UPLOAD_APPEARANCE_IMAGE_REQUEST,
  payload
});

export const uploadAppearanceImageSuccess = (data) => ({
  type: APPEARANCE_ACTION_TYPES.UPLOAD_APPEARANCE_IMAGE_SUCCESS,
  payload: data
});

export const uploadAppearanceImageFailure = (fileId, error) => ({
  type: APPEARANCE_ACTION_TYPES.UPLOAD_APPEARANCE_IMAGE_FAILURE,
  payload: { fileId, error }
});

export const resetCreateStates = () => ({
  type: APPEARANCE_ACTION_TYPES.RESET_CREATE_STATES
});

// Fetch Associated Streams
export const fetchAssociatedStreamsRequest = (payload) => ({
  type: APPEARANCE_ACTION_TYPES.FETCH_ASSOCIATED_STREAMS_REQUEST,
  payload
});

export const fetchAssociatedStreamsSuccess = (data) => ({
  type: APPEARANCE_ACTION_TYPES.FETCH_ASSOCIATED_STREAMS_SUCCESS,
  payload: data
});

export const fetchAssociatedStreamsFailure = (error) => ({
  type: APPEARANCE_ACTION_TYPES.FETCH_ASSOCIATED_STREAMS_FAILURE,
  payload: error
});

// Delete Appearance Image
export const deleteAppearanceImageRequest = (payload) => ({
  type: APPEARANCE_ACTION_TYPES.DELETE_APPEARANCE_IMAGE_REQUEST,
  payload
});

export const deleteAppearanceImageSuccess = (imageId, appearanceId) => ({
  type: APPEARANCE_ACTION_TYPES.DELETE_APPEARANCE_IMAGE_SUCCESS,
  payload: { imageId, appearanceId }
});

export const deleteAppearanceImageFailure = (imageId, error) => ({
  type: APPEARANCE_ACTION_TYPES.DELETE_APPEARANCE_IMAGE_FAILURE,
  payload: { imageId, error }
});
// Download Appearance Images
export const downloadAppearanceImagesRequest = (appearanceId, images) => ({
  type: APPEARANCE_ACTION_TYPES.DOWNLOAD_APPEARANCE_IMAGES_REQUEST,
  payload: { appearanceId, images }
});

export const downloadAppearanceImagesSuccess = (appearanceId, images) => ({
  type: APPEARANCE_ACTION_TYPES.DOWNLOAD_APPEARANCE_IMAGES_SUCCESS,
  payload: { appearanceId, images }
});

export const downloadAppearanceImagesFailure = (appearanceId, error) => ({
  type: APPEARANCE_ACTION_TYPES.DOWNLOAD_APPEARANCE_IMAGES_FAILURE,
  payload: { appearanceId, error }
});

// Enroll Appearance
export const enrollAppearanceRequest = (payload) => ({
  type: APPEARANCE_ACTION_TYPES.ENROLL_APPEARANCE_REQUEST,
  payload
});

export const enrollAppearanceSuccess = (data) => ({
  type: APPEARANCE_ACTION_TYPES.ENROLL_APPEARANCE_SUCCESS,
  payload: data
});

export const enrollAppearanceFailure = (error) => ({
  type: APPEARANCE_ACTION_TYPES.ENROLL_APPEARANCE_FAILURE,
  payload: error
});

export const resetEnrollStates = () => ({
  type: APPEARANCE_ACTION_TYPES.RESET_ENROLL_STATES
});

export const submitAppearanceSuccess = (data) => ({
  type: APPEARANCE_ACTION_TYPES.SUBMIT_APPEARANCE_SUCCESS,
  payload: data
});

export const submitAppearanceFailure = (error) => ({
  type: APPEARANCE_ACTION_TYPES.SUBMIT_APPEARANCE_FAILURE,
  payload: error
});

export const retryFailedImageRequest = (payload) => ({
  type: APPEARANCE_ACTION_TYPES.RETRY_FAILED_IMAGE_REQUEST,
  payload // { imageId, appearanceId, blobUrl, imageName }
});

export const retryFailedImageFailure = () => ({
  type: APPEARANCE_ACTION_TYPES.RETRY_FAILED_IMAGE_FAILURE
});
